import revive_payload_client_4sVQNw7RlN from "/Users/olivermurphy/Code/spas/justhire/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/olivermurphy/Code/spas/justhire/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/olivermurphy/Code/spas/justhire/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/Users/olivermurphy/Code/spas/justhire/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/Users/olivermurphy/Code/spas/justhire/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/Users/olivermurphy/Code/spas/justhire/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/Users/olivermurphy/Code/spas/justhire/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/Users/olivermurphy/Code/spas/justhire/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/Users/olivermurphy/Code/spas/justhire/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/Users/olivermurphy/Code/spas/justhire/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/olivermurphy/Code/spas/justhire/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_KlVwwuJRCL from "/Users/olivermurphy/Code/spas/justhire/node_modules/@storyblok/nuxt/dist/runtime/plugin.mjs";
import vue_gtm_client_stBjLl0OeM from "/Users/olivermurphy/Code/spas/justhire/plugins/vue-gtm.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_KlVwwuJRCL,
  vue_gtm_client_stBjLl0OeM
]